import { ticketSellerRouteNames } from '../routeNames/ticketSellerRouteNames'
import { mainRouteNames } from '../routeNames/mainRouteNames'

import { getPropsFromParams } from '../utils.routing'
import TicketSellerSidebar from './../../components/shared/sidebars/ticket-seller/TicketSellerSidebar.vue'
import TicketsPage from './../../components/ticket-seller/tickets/tickets-page.vue'
import PurchasePage from './../../components/ticket-seller/tickets/purchase-page.vue'
import OrdersPage from './../../components/ticket-seller/orders/orders-page.vue'
import OrderDetailsPage from './../../components/ticket-seller/orders/order-details-page.vue'
import ReportsPage from './../../components/ticket-seller/reports/reports-page.vue'
import ReportPage from './../../components/ticket-seller/reports/report-page.vue'

const ticketsSidebarRoutes = [
  {
    path: '/ticket-seller/tickets',
    name: ticketSellerRouteNames.tickets,
    component: TicketsPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Tickets',
    },
  },
  {
    path: '/ticket-seller/tickets/:eventId',
    props: getPropsFromParams,
    name: ticketSellerRouteNames.purchase,
    component: PurchasePage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Purchase tickets',
    },
  },
]

const ordersSidebarRoutes = [
  {
    path: '/ticket-seller/orders',
    name: ticketSellerRouteNames.orders,
    component: OrdersPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Orders',
    },
  },
  {
    path: '/ticket-seller/orders/:orderId',
    props: getPropsFromParams,
    name: ticketSellerRouteNames.orderDetails,
    component: OrderDetailsPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Order Details',
    },
  },
]

const reportsSidebarRoutes = [
  {
    path: '/ticket-seller/reports',
    props: getPropsFromParams,
    name: ticketSellerRouteNames.reports,
    component: ReportsPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Reports',
    },
  },
  {
    path: '/ticket-seller/report',
    props: getPropsFromParams,
    name: ticketSellerRouteNames.report,
    component: ReportPage,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Report',
    },
  },
]

const ticketSellerSidebarRoutes = [
  ...ticketsSidebarRoutes,
  ...ordersSidebarRoutes,
  ...reportsSidebarRoutes,
]

export const TicketSellerRoutes = [
  {
    path: '/ticket-seller',
    redirect: { name: ticketSellerRouteNames.tickets },
    name: mainRouteNames.ticketSellerSidebar,
    component: TicketSellerSidebar,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
    children: ticketSellerSidebarRoutes,
  },
]
